import { formatDate } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { NgbActiveModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { CommonModalFormComponent } from "@shared/components/commons/common-modal-form/common-modal-form.component";
import { DatePickerComponent } from "@shared/controls/date-picker/date-picker.component";
import { DatepickerHelper } from "@shared/validators/date-picker-form-validators";

@Component({
  selector: 'app-mark-signed',
  standalone: true,
  imports: [
    CommonModalFormComponent,
    DatePickerComponent,
    FormsModule,
  ],
  templateUrl: './mark-signed.component.html',
  styleUrl: './mark-signed.component.scss'
})
export class MarkSignedComponent implements OnInit {
  @Input() earliestLodgeDate?: Date;
  @Output() confirm = new EventEmitter<string>();

  private activeModal = inject(NgbActiveModal);

  signingDate = new Date();
  formattedSigningDate = '';
  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;

  ngOnInit(): void {
    this.minDate = this.earliestLodgeDate ? DatepickerHelper.getStructFromDateOrNull(this.earliestLodgeDate)! : DatepickerHelper.getDefaultMinDateStruct();
    this.maxDate = DatepickerHelper.getTodayStruct();
  }

  agree(): void {
    this.confirm.emit(this.formattedSigningDate);
    this.activeModal.close();
  }

  close(): void {
    this.activeModal.close();
  }

  onSigningDateChange(signingDate: Date | NgbDateStruct): void {
    if(signingDate) {
      const date = signingDate instanceof Date ? signingDate : DatepickerHelper.getDateFromStruct(signingDate);
      this.formattedSigningDate = formatDate(date, 'yyyy-MM-dd', 'en-US');
    }
  }
}
